
const baseUrl= window.SITE_CONFIG.baseUrl?window.SITE_CONFIG.baseUrl:'http://192.168.0.101:8088'

export default {
    baseUrl
}
